export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/patterntap/testim-5b0f99b4015e520d46422834a3900c4a.png";